import { createSlice } from "@reduxjs/toolkit";
import { OemModalFieldsJSON } from "../../pages/Product/Oem/Json/OemFieldsJson";
import { OEM_FROM_DATE, OEM_TO_DATE } from "../../Utils/FilterDateKeys";
import dateFormat from "dateformat";
import { oemTabs } from "../../pages/Product/Oem/Json/OemJson";

const initialState = {
  oemData: [],
  oemFieldJson: OemModalFieldsJSON,
  oemEdit: {
    id: null,
  },
  selectedOem: {
    tabs: oemTabs,
    activeTab: "details",
    detailsData: {},
  },
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [OEM_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [OEM_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const oemSlice = createSlice({
  name: "oem",
  initialState,
  reducers: {
    setOemData(state, action) {
      state.oemData = action.payload;
    },
    setOemFieldJson(state, action) {
      state.oemFieldJson = action.payload;
    },
    setOemEditID(state, action) {
      state.oemEdit.id = action.payload;
    },
    setOemFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setOemFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // enterpriseid: enterpriseid,
            // [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[OEM_FROM_DATE];
          delete state.filter.form[OEM_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setOemFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setOemSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    changeActiveTab: (state, action) => {
      state.selectedOem.activeTab = action.payload;
    },
    setDetailsData: (state, action) => {
      state.selectedOem.detailsData = action.payload;
    },
  },
});

export const {
  setOemData,
  setOemFieldJson,
  setOemEditID,
  setOemFilterApi,
  setOemFilterForm,
  setOemFilterFormCopy,
  setOemSorting,
  changeActiveTab,
  setDetailsData
} = oemSlice.actions;

export default oemSlice.reducer;
